import LabelsCell from './LabelsCell';

export default LabelsCell;
